import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';

export default function HubspotSettings() {
	const formManager = FormManager();

	var Integration = function () {
		var instanceVars = {
			active_integration: null,

			initialise: function () {
				const urlParams = new URLSearchParams(window.location.search);
				if (urlParams.get('code')) {
					this.createIntegration(urlParams.get('code'), urlParams.get('state') || null);
				} else {
					this.getSellerData();
				}
				this.addListeners();
			},

			getSellerData: function () {
				var t = this;
				Bark.api(
					'seller/integration/',
					{ partner: 'hubspot' },
					function (data) {
						$('.waiting').removeClass('waiting');
						if (data.integration != null) {
							$('#partner-initial-link').hide();

							if (
								data.integration.partner_config != null &&
								data.integration.partner_config.length > 0
							) {
								data.integration.partner_config = JSON.parse(
									data.integration.partner_config,
								);
								t.showHubspotSettings();
							} else {
								t.showHubspotSettings();
								data.integration.partner_config = null;
							}
						} else {
							$('#hbDealSettings').hide();
						}

						t.active_integration = data.integration;
						t.updateLayout();
					},
					function (error) {
						t.setHubspotError(_t('seller_settings_hubspot:errors.integration-failed'));
						bugsnagClient.notify(new Error('Partner integration call failed'), {
							metaData: error,
						});
					},
					'GET',
					Bark.apiVersionHeader('v2'),
				);
			},

			updateLayout: function () {
				if (this.active_integration == null) {
					$('#contHbToggle').hide();
					$('.hb_unlinked').removeClass('d-none');
					$('.hb_linked').addClass('d-none');
					$('.contHbBark h5').text(_t('seller_settings_hubspot:dynamic-content.sync-with-bark'));
				} else {
					$('.hb_linked').removeClass('d-none');
					$('.hb_unlinked').addClass('d-none');
					$('#contHbToggle').fadeIn();
					$('.contHbBark h5').text(_t('seller_settings_hubspot:dynamic-content.with-bark'));

					if (window.Bark.GET('settings') != 'true') $('#hbDealSettings').fadeIn();
				}

				if (this.active_integration == null || this.active_integration.is_enabled == 0) {
					$('#enable-integration').prop('checked', false);
					$('.partner-disabled-only').show();
					$('.partner-enabled-only').hide();
					$('#contSettings').hide();
					$('p.js-hubspot-toggle-text').text(_t('seller_settings_hubspot:dynamic-content.integration-disabled'));
				} else {
					$('#enable-integration').prop('checked', true);
					$('p.js-hubspot-toggle-text').text(_t('seller_settings_hubspot:dynamic-content.integration-enabled'));
					$('.partner-disabled-only').hide();
					$('.partner-enabled-only').show();
					if (window.Bark.GET('settings') != 'true') $('#hbDealSettings').fadeIn();
					$('#contSettings').fadeIn();
				}
			},

			showHubspotSettings: function () {
				var t = this;

				Bark.showLoading();
				Bark.api(
					'seller/integration/hubspot/lookups/',
					{},
					function (data) {
						if (!data.status) {
							if (data.relink) {
								t.getOAuthLink();
								return;
							}
							t.setHubspotError(data.error);
							return;
						}

						$contactListSelect.empty();
						$dealPipeSelect.empty();

						$contactListSelect.append(
							$('<option>', { value: '' }).text(_t('seller_settings_hubspot:errors.no-contact-list')),
						);

						for (var i = 0; i < data.contacts_lists.length; i++) {
							$contactListSelect.append(
								$('<option>', { value: data.contacts_lists[i].listId }).text(
									data.contacts_lists[i].name,
								),
							);
						}

						for (var i = 0; i < data.deal_pipelines.length; i++) {
							var stages = data.deal_pipelines[i].stages;
							stages.sort(function (x, y) {
								if (x['displayOrder'] < y['displayOrder']) {
									return -1;
								}
								if (x['displayOrder'] > y['displayOrder']) {
									return 1;
								}
								return 0;
							});

							for (var a = 0; a < stages.length; a++) {
								$dealPipeSelect.append(
									$('<option>', {
										value: data.deal_pipelines[i].pipelineId + '|' + stages[a].stageId,
									}).text(data.deal_pipelines[i].label + ' - ' + stages[a].label),
								);
							}
						}

						if (
							t.active_integration != null &&
							t.active_integration.partner_config != null
						) {
							$contactListSelect.val(t.active_integration.partner_config.contact_list_id);
							$dealPipeSelect.val(
								t.active_integration.partner_config.deal_pipeline_id +
									'|' +
									t.active_integration.partner_config.deal_pipeline_stage,
							);
						}

						Bark.hideLoading();
						$('#contHbToggle').fadeIn();

						if (window.Bark.GET('settings') == 'true') {
							if (history && history.replaceState)
								history.replaceState &&
									history.replaceState(
										null,
										'',
										location.pathname +
											location.search
												.replace(/[\?&]settings=[^&]+/, '')
												.replace(/^&/, '?'),
									);

							var modal = $('#hubspot-settings-modal');
							modal.modal({
								backdrop: 'static',
								show: true,
								keyboard: false,
							});
							$('#hbDealSettings').hide();
						} else {
							if (!$('#hubspot-settings-modal').hasClass('show'))
								$('#hbDealSettings').fadeIn();
						}
					},
					function (error) {
						t.setHubspotError(_t('seller_settings_hubspot:errors.link-failed'));
						bugsnagClient.notify(new Error('HubSpot OAuth link call failed'), {
							metaData: error,
						});
					},
					'GET',
					Bark.apiVersionHeader('v2'),
				);
			},

			saveHubspotSettings: function (defer) {
				var t = this;
				Bark.showLoading();
				$('#hubspot-settings-error').addClass('d-none');

				var deal_pipeline_values = $dealPipeSelect.val().split('|');
				var clistId = $contactListSelect.val();
				var clistName = $('.contact-list-select option:selected').text();
				var dPname = $('.deal-pipeline-select option:selected').text();

				if ($('#hubspot-settings-modal').hasClass('show')) {
					deal_pipeline_values = $mdlDealPipeSelect.val().split('|');
					clistId = $mdlContactListSelect.val();
					clistName = $(
						'#hubspot-settings-modal .contact-list-select option:selected',
					).text();
					dPname = $(
						'#hubspot-settings-modal .deal-pipeline-select option:selected',
					).text();
				}

				var config_data = {
					contact_list_id: clistId,
					contact_list_name: clistName,
					deal_pipeline_name: dPname,
					deal_pipeline_id: deal_pipeline_values[0],
					deal_pipeline_stage: deal_pipeline_values[1],
				};

				Bark.api(
					'seller/integration/hubspot/settings/',
					config_data,
					function (data) {
						if (defer) {
							defer.resolve();
							formManager.dirty('deal-pipeline-select', false);
							formManager.dirty('contact-list-select', false);
						}

						if (!data.status) {
							t.setHubspotDialogError(data.error);
							return;
						} else {
							t.showHubspotSettings();
						}

						Bark.hideLoading();

						if (t.active_integration == null) {
							t.active_integration = {
								is_enabled: 1,
								partner_config: config_data,
							};
						} else {
							t.active_integration.is_enabled = 1;
							t.active_integration.partner_config = config_data;
						}

						t.updateLayout();

						var modal = $('#hubspot-settings-modal');
						modal.modal('hide');
					},
					function (error) {
						if (defer) defer.resolve();

						t.setHubspotDialogError(_t('seller_settings_hubspot:errors.cant-save'));
						bugsnagClient.notify(new Error('HubSpot OAuth link call failed'), {
							metaData: error,
						});
						return;
					},
					'POST',
					Bark.apiVersionHeader('v2'),
				);
			},

			handleEnableDisable: function () {
				if (this.active_integration == null) {
					$('#bark-modal-link').modal('show');
					return;
				}

				if (
					this.active_integration.partner_config == null ||
					this.active_integration.partner_config.length == 0
				) {
					this.showHubspotSettings();
					return;
				}

				if (this.active_integration.is_enabled == 1) {
					$('#bark-modal-disable').modal('show');
					return;
				}

				this.showHubspotSettings();

				this.enableHubspot();
			},

			unlinkHubspot: function () {
				var t = this;
				Bark.showLoading();
				$('#bark-modal-unlink').modal('hide');

				var data = {
					partner: 'hubspot',
				};

				Bark.api(
					'seller/integration/',
					data,
					function (data) {
						if (!data.status) {
							t.setHubspotError(data.error);
							return;
						}

						Bark.hideLoading();

						t.active_integration = null;
						t.updateLayout();

						var modal = $('#hubspot-settings-modal');
						modal.modal('hide');
					},
					function (error) {
						bugsnagClient.notify(new Error('HubSpot unlink call failed'), {
							metaData: error,
						});
						t.setHubspotError(_t('seller_settings_hubspot:errors.unlink-failed'));
						return;
					},
					'DELETE',
					Bark.apiVersionHeader('v2'),
				);
			},

			disableHubspot: function () {
				var t = this;
				Bark.showLoading();
				$('#bark-modal-disable').modal('hide');

				var data = {
					partner: 'hubspot',
					is_enabled: 0,
				};

				Bark.api(
					'seller/integration/enabled/',
					data,
					function (data) {
						if (!data.status) {
							t.setHubspotError(data.error);
							return;
						}

						Bark.hideLoading();

						t.active_integration.is_enabled = 0;
						t.updateLayout();

						var modal = $('#hubspot-settings-modal');
						modal.modal('hide');
					},
					function (error) {
						bugsnagClient.notify(new Error('HubSpot unlink call failed'), {
							metaData: error,
						});
						t.setHubspotError(_t('seller_settings_hubspot:errors.cant-disable'));
						return;
					},
					'POST',
					Bark.apiVersionHeader('v2'),
				);
			},

			enableHubspot: function () {
				var t = this;
				Bark.showLoading();

				var data = {
					partner: 'hubspot',
					is_enabled: 1,
				};

				Bark.api(
					'seller/integration/enabled/',
					data,
					function (data) {
						if (!data.status) {
							t.setHubspotError(data.error);
							return;
						}

						Bark.hideLoading();

						t.active_integration.is_enabled = 1;
						t.updateLayout();

						var modal = $('#hubspot-settings-modal');
						modal.modal('hide');
					},
					function (error) {
						bugsnagClient.notify(new Error('HubSpot unlink call failed'), {
							metaData: error,
						});
						t.setHubspotError(_t('seller_settings_hubspot:errors.cant-disable'));
						return;
					},
					'POST',
					Bark.apiVersionHeader('v2'),
				);
			},
			getOAuthLink: function () {
				var t = this;
				$('.general-error').addClass('d-none');
				Bark.showLoading();
				Bark.api(
					'seller/integration/hubspot/oauth-link/',
					{},
					function (data) {
						if (!data.status) {
							t.setHubspotLinkError(data.error);
							return;
						}
						window.location.href = data.url;
					},
					function (error) {
						t.setHubspotLinkError(_t('seller_settings_hubspot:errors.link-failed'));
						bugsnagClient.notify(new Error('HubSpot OAuth link call failed'), {
							metaData: error,
						});
					},
					'GET',
					Bark.apiVersionHeader('v2'),
				);
			},

			createIntegration: function (code, state) {
				$('.general-error').addClass('d-none');
				var t = this;
				Bark.api(
					'seller/integration/hubspot/',
					{
                        code: code,
                        state: state,
                    },
					function (data) {
						if (!data.status) {
							t.setHubspotError(data.error);
							return;
						}
						window.location.replace('/settings/integrations/hubspot/?settings=true');
					},
					function (error) {
						t.setHubspotError(_t('seller_settings_hubspot:errors.link-failed'));
						bugsnagClient.notify(new Error('HubSpot integration creation failed'), {
							metaData: error,
						});
					},
					'POST',
					Bark.apiVersionHeader('v2'),
				);
			},

			redraw: function (data) {
				var length = data.data.length;

				if (length > 0) {
					this.checkAutoSave();
					this.renderTemplates(data.data);
				} else {
					this.renderNoTemplates();
				}

				$('.waiting').removeClass('waiting');
			},
			setHubspotError: function (msg) {
				$('.general-error .js-error-text').text(msg);
				$('.general-error').removeClass('d-none');
				Bark.hideLoading();
				var modal = $('#hubspot-settings-modal');
				modal.modal('hide');
				$('.waiting').removeClass('waiting');
				this.updateLayout();
			},
			setHubspotDialogError: function (msg) {
				$('#hubspot-settings-error .js-error-text').text(msg);
				$('#hubspot-settings-error').removeClass('d-none');
				Bark.hideLoading();
			},
			setHubspotLinkError: function (msg) {
				this.setHubspotError(msg);
				var modal = $('#bark-modal-link');
				modal.modal('hide');
			},
			setError: function (msg) {
				$('.js-error-text').text(msg);
				$('.general-error').removeClass('d-none');
			},
			updateFailed: function (defer) {
				if (defer) defer.reject($('#one-click-message'));
			},

			addListeners: function () {
				var integration = this;

				$('#hubspot-settings-modal')
					.off('hide.bs.modal')
					.on('hide.bs.modal', function () {
						$('#hbDealSettings').fadeIn();
					});

				formManager.register(
					'deal-pipeline-select',
					function (deferred) {
						integration.saveHubspotSettings(deferred);
					},
					function () {
						$dealPipeSelect
							.val(
								integration.active_integration.partner_config.deal_pipeline_id +
									'|' +
									integration.active_integration.partner_config.deal_pipeline_stage,
							)
							.trigger('change');
					},
				);

				formManager.register(
					'contact-list-select',
					function (deferred) {
						integration.saveHubspotSettings(deferred);
					},
					function () {
						$contactListSelect
							.val(integration.active_integration.partner_config.contact_list_id)
							.trigger('change');
					},
				);

				$('#contSettings select.contact-list-select')
					.off('change')
					.on('change', function () {
						formManager.dirty(
							'contact-list-select',
							integration.active_integration.partner_config.contact_list_id !==
								$(this).val().trim(),
						);
					});

				$('#contSettings select.deal-pipeline-select')
					.off('change')
					.on('change', function () {
						formManager.dirty(
							'deal-pipeline-select',
							integration.active_integration.partner_config.deal_pipeline_id +
								'|' +
								integration.active_integration.partner_config.deal_pipeline_stage !==
								$(this).val().trim(),
						);
					});

				$('.hubspot-link').on('click', function (event) {
					event.preventDefault();
					integration.getOAuthLink();
				});
				$('#hubspot-settings-modal .btn-primary').on('click', function (event) {
					integration.saveHubspotSettings();
				});
				$('#show-partner-settings').on('click', function (event) {
					event.preventDefault();
					integration.showHubspotSettings();
				});
				$('#partner-unlink-link').on('click', function (event) {
					event.preventDefault();
					$('#bark-modal-unlink').modal('show');
				});
				$('#enable-partner-integration').on('click', function (event) {
					event.preventDefault();
					integration.handleEnableDisable();
				});
				$('#unlink-confirm').on('click', function (event) {
					event.preventDefault();
					integration.unlinkHubspot();
				});
				$('#disable-confirm').on('click', function (event) {
					event.preventDefault();
					integration.disableHubspot();
				});
			},
		};

		const _this = Object.assign({}, instanceVars);
		_this.initialise();
	};

	var $contactListSelect = $('.contact-list-select');
	var $mdlContactListSelect = $('.mdl-contact-list-select');
	var $dealPipeSelect = $('.deal-pipeline-select');
	var $mdlDealPipeSelect = $('.mdl-deal-pipeline-select');
	var Integration = Integration();
}
